import { SCHEMA_ADD, SCHEMA_ADD_LISTING } from './types';

export const addSchema = (data, theme) => ({
  type: SCHEMA_ADD,
  payload: {
    schema: theme,
    data,
  },
});

export const addListingsSchema = (data, theme) => ({
  type: SCHEMA_ADD_LISTING,
  payload: {
    schema: theme,
    data,
  },
});



// WEBPACK FOOTER //
// ./src/redux/actions/schemaActions.js